import { render, staticRenderFns } from "./FormTinyEditor.vue?vue&type=template&id=5fc916cb&"
import script from "./FormTinyEditor.vue?vue&type=script&lang=js&"
export * from "./FormTinyEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports